import React, { useEffect } from 'react';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';
import PurchaseOrders from 'types/entities/PurchaseOrders';
import CheckboxSelection from 'components/CheckboxSelection/CheckboxSelection';
import { getPurchaseOrderAction } from 'store/actions/purchaseOrderActions';

const DefaultCell = React.memo((row: PurchaseOrders) => {
  const state = useSelector((state) => state.purchaseOrder);
  const { dispatch } = useAppState();
  const [checked, setChecked] = React.useState(false);

  useEffect(() => {
    setChecked(row?.is_valid);
  }, [row?.is_valid]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (state?.datas) {
      const updatedData: { datas: PurchaseOrders[] } = {
        datas: state?.datas?.map((order) => ({
          ...order,
          is_valid: event.target.checked ? order.id === row.id : false,
        })),
      };

      dispatch(getPurchaseOrderAction(updatedData?.datas));
    }
  };

  return <CheckboxSelection onChange={(e) => handleChange(e)} label="" checked={checked} disabled={row.is_archived} />;
});

export default DefaultCell;
